export default __webpack_public_path__ + "static/media/cross-dark.ac5e1124.svg";